"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = theme => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        flexGrow: 1,
        overflowY: 'hidden',
        borderRadius: '0 0 3px 3px',
        position: 'relative',
        '&::before': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            height: 14,
            backgroundColor: theme.grey8,
            borderRadius: '0 0 3px 3px',
            zIndex: -1,
            boxShadow: `0 2px 2px 0 rgba(29,3,89, 0.5)`
        }
    },
    body: {
        flexGrow: 1,
        overflowY: 'auto',
        borderRadius: 'inherit',
        overflowScrolling: 'touch'
    },
    content: {
        backgroundColor: theme.grey8,
        borderRadius: 'inherit',
        borderTopLeftRadius: 3,
        borderTopRightRadius: 3
    }
});
//# sourceMappingURL=atc.group.body.style.js.map